import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { bannerQueryKey } from 'app/_components/Main/api/queries';
import { faqQueryKey } from 'app/faq/_features/api/queries';
import { exchangeQueryKey } from 'app/myviewup/_entities/exchange/api/queries';
import { accountSettingQueryKey } from 'app/myviewup/account/settings/_features/api/queries';
import { infoQueryKey } from 'app/myviewup/info/_features/api/queries';
import { refundQueryKey } from 'app/myviewup/refund/_features/api/queries';
import { noticeQueryKey } from 'app/notice/_features/queries';
import { pointRankingQueryKey } from 'app/ranking/_features/api/queries';
import { signupQueryKey } from 'app/signup/_features/api/queries';
import { dailyCheckInQueryKey } from 'app/stamp/_entities/api/queries';
import { clickViewingQueryKey } from 'app/viewing/_entities/click/api/queries';
import { viewingCommonQueryKey } from 'app/viewing/_entities/common/api/queries';
import { postingViewingQueryKey } from 'app/viewing/_entities/post/api/queries';
import { viewingMoneyQueryKey } from 'app/viewing-money/_features/api/queries';

export const queryKey = mergeQueryKeys(
  postingViewingQueryKey,
  viewingCommonQueryKey,
  clickViewingQueryKey,
  accountSettingQueryKey,
  exchangeQueryKey,
  infoQueryKey,
  refundQueryKey,
  viewingMoneyQueryKey,
  pointRankingQueryKey,
  dailyCheckInQueryKey,
  noticeQueryKey,
  faqQueryKey,
  signupQueryKey,
  bannerQueryKey,
);
